import React from 'react';
import cn from 'classname';
import './index.less';

import { connect } from 'react-redux';

import withIntl from '../../../../shared/intl-hoc';

const background = {
	en: require('../../../../../apps/rocket/assets/img/dashboard/reviews-on-offerhubs-en.png'),
	ru: require('../../../../../apps/rocket/assets/img/dashboard/reviews-on-offerhubs-ru.png')
};

const links = [
	'https://partnerkin.com/c/7/rocketprofit',
	'https://conversion.im/affiliate_networks/rocketprofit',
	'https://affbank.com/cpa-networks/rocketprofit',
	'https://cpa.rip/partners/rocketprofit/',
	'https://protraffic.com/affiliate_program/rocketprofit',
	'https://cpainform.ru/networks/rocketprofit/opinions/'
];

function Banner({ className, manager, intl, onClick }) {
	const lang = intl.language === 'ru' ? 'ru' : 'en';

	return (
		<div
			className={cn('reviews-on-offerhubs', className)}
			style={{
				backgroundImage: `url('${background[lang]}')`
			}}
		>
			{links.map((link, i) => (
				<a target='_blank' rel='noreferrer' href={link} key={i} />
			))}
			{manager.telegram && (
				<div className={cn('roo-manager-telegram', lang)}>
					@{manager.telegram}
				</div>
			)}
			{manager.avatar && (
				<div className={cn('roo-manager-avatar', lang)}>
					<img src={manager.avatar} />
				</div>
			)}
			<button
				onClick={() => {
					window.open(`https://t.me/${manager.telegram}`, '_blank');
					onClick();
				}}
			/>
		</div>
	);
}

function mapStateToProps(state) {
	return {
		manager: state.dashboard.data.manager
	};
}

export default withIntl(connect(mapStateToProps)(Banner));



// WEBPACK FOOTER //
// ./frontend/cabinets/modules/shared/banner/custom-banners/reviews-on-offerhubs/index.js